import { useHistory } from 'react-router-dom'

import { HOME } from '../../routes'
import { useUserContext } from '../../auth/UserProvider'
import ShippingSendMobileUI from '../../ui/views/ShippingSendMobile'
import Form from './Form'

const ShippingSendMobile = () => {
  const history = useHistory()
  const userData = useUserContext()
  const isLoading = !Boolean(userData) || userData.isLoading

  const goToHome = () => {
    history.push(HOME.linkTo())
  }
  return (
    <ShippingSendMobileUI isLoading={isLoading} onClose={goToHome}>
      {Boolean(userData?.centres) ? <Form userData={userData} /> : null}
    </ShippingSendMobileUI>
  )
}

export default ShippingSendMobile
